// Which catalog types may be offered where a WALL is chosen (the Review · Walls chooser, the wall condition's type, a room's
// wall system). They listed EVERY linear item — liner ceiling, floor bumper rail, pipe rack — so a wall could be given a
// ceiling type (feedback #25). A type counts as a wall when it sits on a Takeoff Layer whose name says wall / drywall /
// partition (Setup ▸ Estimate Engine ▸ Takeoff Layers: "Cleanroom Walls 2\"", "Drywall", …).
//
// Until an admin has put at least one linear type on such a layer there is nothing to narrow by, so every linear type is
// still offered (never an empty list). `layers` = the active Takeoff Layers rows ({ LayerID, LayerKey, Name }).

const WALL_WORDS = /wall|drywall|partition/i;

export const isWallLayer = (layer) => !!layer && (WALL_WORDS.test(layer.Name || "") || WALL_WORDS.test(layer.LayerKey || ""));

/** -> the linear types to offer as walls. `types` rows carry Style and LayerID (items, assemblies, or condition types). */
export function wallSystemTypes(types = [], layers = []) {
  const linear = types.filter(t => t && t.Style === "linear");
  const wallLayerIds = new Set(layers.filter(isWallLayer).map(l => l.LayerID));
  if (!wallLayerIds.size) return linear;
  const walls = linear.filter(t => t.LayerID != null && wallLayerIds.has(t.LayerID));
  return walls.length ? walls : linear;
}

/** Whether narrowing is active (some linear type is on a wall layer) — lets a picker say "walls only". */
export const wallNarrowingActive = (types = [], layers = []) => {
  const all = types.filter(t => t && t.Style === "linear");
  return wallSystemTypes(types, layers).length < all.length;
};
